import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

const KpiCardSkeleton = () => {
  return (
    <div
      className="h-100"
      style={{
        borderRadius: 14,
        border: "1px solid #E2E8F0",
        background: "#FFFFFF",
        boxShadow: "0 6px 14px rgba(15, 23, 42, 0.06)",
        padding: "0.5rem",
      }}
    >
      <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
        <div className="d-flex align-items-center gap-2 min-w-0 flex-grow-1">
          <Skeleton height={28} width={28} borderRadius={8} />
          <Skeleton height={14} width="70%" />
        </div>
        <Skeleton height={18} width={56} />
      </div>
      <div
        className="d-flex align-items-center justify-content-between gap-2 pt-2"
        style={{ borderTop: "1px solid #F1F5F9" }}
      >
        <div className="d-flex align-items-center gap-2 min-w-0 flex-grow-1">
          <Skeleton height={28} width={28} borderRadius={8} />
          <Skeleton height={14} width="65%" />
        </div>
        <Skeleton height={18} width={48} />
      </div>
    </div>
  );
};

export const KpisContainerSkeleton = () => {
  return (
    <Row className="g-2 mb-3">
      {Array.from({ length: 4 }).map((_, index) => (
        <Col xl={3} lg={3} md={6} sm={12} key={index}>
          <KpiCardSkeleton />
        </Col>
      ))}
    </Row>
  );
};
